import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDepartments } from '../../../../interface/interfaces';

interface IInitialState {
    departmentNetworkConnection: IDepartments[];
}

const initialState: IInitialState = {
    departmentNetworkConnection: [],
};

const departmentNetworkSlice = createSlice({
    name: 'departmentNetwork',
    initialState,
    reducers: {
        generateDepartmentNetwork: (state: IInitialState, action: PayloadAction<IDepartments[]>) => {
            state.departmentNetworkConnection = action.payload || [];
        },

        clearDepartmentNetwork: (state: IInitialState) => {
            state.departmentNetworkConnection = [];
        },
    },
});

export default departmentNetworkSlice.reducer;
export const { generateDepartmentNetwork, clearDepartmentNetwork } = departmentNetworkSlice.actions;
